export { default } from './fetchFastPass'